import React from "react";
import IconFooter from "assets/images/logo_footer.svg";
import { useTranslation } from "react-i18next";

import * as S from "./style";

function Footer() {
  const { t, i18n } = useTranslation("common");

  return (
    <S.Container>
      <div className="container">
        <div className="item-container">
          <div className="row">
            <div className="title">COMPANY</div>
            <div
              className={
                i18n.language === "en"
                  ? "english-class content"
                  : "other-language content"
              }
            >
              <div>{t("FOOTER_COMPANY")}</div>
              <div>{t("FOOTER_CEO")}</div>
              <div>{t("FOOTER_ADDRESS")}</div>
              <div>
                <span
                  className="dot"
                  style={{
                    display: `${i18n.language === "en" ? "block" : "none"}`,
                  }}
                />
                {t("FOOTER_ADDRESS_1")}
              </div>
              <div>
                <span
                  className="dot"
                  style={{
                    display: `${i18n.language === "en" ? "block" : "none"}`,
                  }}
                />
                {t("FOOTER_ADDRESS_2")}
              </div>
              <div>{t("FOOTER_PHONE")}</div>
            </div>
          </div>
          <div className="row">
            <div className="title">CONTACT</div>
            <div className="content">
              <div className="number-phones">02-514-0772 / 070-5015-0772</div>
              <div className="time">{t("FOOTER_WORK")}</div>
              <div className="time">{t("FOOTER_LUNCH")}</div>
            </div>
          </div>
        </div>

        <div className="logo">
          <img src={IconFooter} alt="logo footer" />
        </div>

        <div className="note">© Yeolmaecompany. all rights reserved.</div>
      </div>
    </S.Container>
  );
}

export default Footer;
